import { FormattedCurrencyValue } from '../../../elements/Table/TableCell';
import ProxyBidModal from './ProxyBidModal';

// NOTE: we can use a function to build a path to a page (see bodySchema for buttons)
export const buildProxyBidEditRoute = (auctionId, proxyBidID) =>
  `/auction/${auctionId}/proxyBids/${proxyBidID}/edit`;

export const buildProxyBidDeleteRoute = (auctionId, proxyBidID) =>
  `/auction/${auctionId}/proxyBids/${proxyBidID}/delete`;

export const tableSettings = {
  searchFields: [
    { label: 'Lot Number', param: 'LotNumber' },
    { label: 'Stock Number', param: 'StockNumber' },
    { label: 'Product Name', param: 'ProductName', inputWidth: '400px' },
  ],
  pageSelectTitle: 'Proxy Bids',
  initialSortColumn: 'lotNumber',
  initialSortDirection: 'asc',
  standardStoreParams: [
    'pageNumber',
    'pageSize',
    'searchText',
    'sortColumn',
    'sortDirection',
  ],
  getMethods: (proxies) => {
    return {
      name: 'proxies',
      fn: proxies.fn,
      args: ['auctionID', ...tableSettings.standardStoreParams],
      dataToMerge: { auctionID: proxies.auctionId },
    };
  },
};

const headerSchema = [
  { index: 8, value: '', text: 'Action', sort: false },
  { index: 1, value: 'proxyBid', text: 'ProxyBid Amount', sort: true },
  {
    index: 2,
    value: 'bidTime',
    text: 'Bid Time',
    sort: true,
  },
  { index: 3, value: 'bidderNumber', text: 'Bidder Number', sort: true },
  { index: 4, value: 'memberName', text: 'Member', sort: true },
  { index: 5, value: 'lane', text: 'Lane Name', sort: true },
  {
    index: 6,
    value: 'lotNumber',
    text: 'Lot Number',
    sort: true,
    initialSort: true,
  },
  { index: 7, value: 'product', text: 'Product Name', sort: true },
];

const bodySchema = [
  {
    index: 8,
    debug: false,
    value: ['auctionID', 'proxyBidID'],
    text: 'edit proxy1',
    content: {
      type: 'tableButtons',
      value: [
        {
          value: 'proxyBidID',
          text: 'Edit/Delete',
          icon: 'edit',
          fn: 'proxyStateObject',
          // fn: "proxyBidStateObject",
          // fn: buildProxyBidEditRoute,
          url: 'fn',
          args: [
            'auctionID',
            'proxyBidID',
            'proxyBid',
            'bidderNumber',
            'lotNumber',
            'memberName',
          ],
          // url: [
          //   'auction',
          //   '[auctionID]',
          //   'proxyBids',
          //   '[proxyBidID]',
          //   'edit'
          // ],
          key: '[proxyBidID]',
        },
      ],
    },
  },
  {
    index: 1,
    value: 'proxyBid',
    content: { type: 'text', value: 'value' },
    format: 'currency',
    component: FormattedCurrencyValue,
  },
  {
    index: 2,
    value: 'bidTime',
    content: { type: 'datetime', value: 'value' },
    format: 'MM/DD/YYYY h:mm:ss A',
  },
  {
    index: 3,
    value: 'bidderNumber',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 4,
    value: 'memberName',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 5,
    value: 'lane',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 6,
    value: 'lotNumber',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 7,
    value: 'product',
    content: { type: 'text', value: 'value' },
  },
];

export const schema = {
  tableSettings,
  headerSchema,
  bodySchema,
  debugging: false,
};
